import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState, useEffect, useMemo } from 'react';
import classnames from 'classnames';
import { ThemeProvider } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import { TextTooltip } from '../tooltip';
import useId from '@mui/utils/useId';
import { EmbersCheckbox } from './checkbox';
import { GROUP_FORM_GROUP, checkBoxGroupTheme } from './checkboxStyles';
import { isTouchDevices } from '../utils/platformUtils';
export var EmbersCheckboxGroup = function EmbersCheckboxGroup(_ref) {
  var className = _ref.className,
    groupLabel = _ref.groupLabel,
    name = _ref.name,
    value = _ref.value,
    onChange = _ref.onChange,
    options = _ref.options,
    _ref$row = _ref.row,
    row = _ref$row === void 0 ? false : _ref$row,
    _ref$labelClickable = _ref.labelClickable,
    labelClickable = _ref$labelClickable === void 0 ? true : _ref$labelClickable,
    groupTooltip = _ref.groupTooltip,
    groupTooltipProps = _ref.groupTooltipProps;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValues = _useState2[0],
    setSelectedValues = _useState2[1];
  var isTouchDevice = isTouchDevices();
  useEffect(function () {
    setSelectedValues(value || []);
  }, [value]);
  var omitUnselectedId = function omitUnselectedId(ids, id) {
    var index = ids.findIndex(function (selectedId) {
      return selectedId === id;
    });
    return ids.slice(0, index).concat(ids.slice(index + 1));
  };
  var onDataChange = function onDataChange(index) {
    return function (e, checked) {
      var value = options[index].value;
      var result;
      if (checked) {
        result = [].concat(_toConsumableArray(selectedValues), [value]);
      } else {
        result = omitUnselectedId(selectedValues, value);
      }
      setSelectedValues(result);
      onChange === null || onChange === void 0 || onChange(result);
    };
  };
  var labelId = useId();
  var formLabelProps = useMemo(function () {
    return {
      id: labelId
    };
  }, [labelId]);
  var formGroupProps = useMemo(function () {
    var extraFormGroupProps = {};
    if (groupLabel && labelId) {
      extraFormGroupProps['role'] = 'group';
      extraFormGroupProps['aria-labelledby'] = labelId;
    } else if (name) {
      extraFormGroupProps['role'] = 'group';
      extraFormGroupProps['aria-label'] = name;
    }
    return _objectSpread({
      name: name,
      row: row,
      className: "".concat(GROUP_FORM_GROUP, "-items")
    }, extraFormGroupProps);
  }, [groupLabel, name, row, labelId]);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: checkBoxGroupTheme
  }, /*#__PURE__*/React.createElement(FormControl, {
    className: classnames("".concat(GROUP_FORM_GROUP, "-root"), className)
  }, groupLabel && (groupTooltip ? /*#__PURE__*/React.createElement(TextTooltip, _extends({}, groupTooltipProps, {
    tooltipProps: _objectSpread({
      type: 'info',
      placement: isTouchDevice ? undefined : 'right-start',
      title: groupTooltip
    }, groupTooltipProps === null || groupTooltipProps === void 0 ? void 0 : groupTooltipProps.tooltipProps),
    className: "".concat(GROUP_FORM_GROUP, "-tooltip")
  }), /*#__PURE__*/React.createElement(FormLabel, formLabelProps, groupLabel)) : /*#__PURE__*/React.createElement(FormLabel, formLabelProps, groupLabel)), /*#__PURE__*/React.createElement(FormGroup, formGroupProps, options.map(function (v, index) {
    return /*#__PURE__*/React.createElement(EmbersCheckbox, _extends({
      key: index
    }, v, {
      labelClickable: labelClickable,
      checked: selectedValues.includes(v.value),
      onChange: onDataChange(index),
      className: "".concat(GROUP_FORM_GROUP, "-item")
    }));
  }))));
};